import script from "./TC.vue?vue&type=script&lang=js"
export * from "./TC.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__